<template>
    <div v-if="this.$route.params.i != '' && this.$route.params.i !=0 && this.$route.params.c == 'c=BERFR'">
        <div class="header" id="header-bermudes">
            <div id="header-top">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12 col-sm-5 d-flex justify-content-satrt">
                            <div class="header__top-infos">
                                <div>
                                    <a href="tel:0033 (0)2 98 90 10 29">
                                        <i class="fa fa-phone-alt"></i> 0033 (0)2 98 90 10 29
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a href="https://www.bermudes.com">
                <img class="arm-logo-bermudes" src="/Logo-Bermudes.svg" alt="Logo_bermudes">
            </a>
        </div>
    </div>
    <div v-else-if="this.$route.params.i != '' && this.$route.params.i !=0 && this.$route.params.c == 'c=CMFR'">
        <div class="header" id="header-comptoirMaritime">
          <div id="header-top-CM"></div>
          
          <a href="https://lecomptoirmaritime.com/">
            <img class="logo-comptoirMaritime" src="/logo-cm-black.png" alt="Logo_Comptoir_Maritime">
          </a>
        </div>
    </div>
    <div v-else>
        <div class="header"  id="header-armor">
            <a href="https://www.armorlux.com">
                <img class="arm-logo-armor" src="/armor-lux_840px.jpg" alt="Logo_armor">
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header'
    }
</script>

<style scoped>
 
  .header {
    text-align: center;
  }

  #header-armor {
    border-bottom:1px solid var(--vt-c-red);
  }


  /*** BERMUDES */
  .header .arm-logo-armor{
    margin-top:20px;
    margin-bottom:20px; 
    height:30px
  }

  #header-bermudes {
    border-bottom:1px solid #195078 ; 
  }
  

  #header-top a{
 
    color:white;
  
  }

  #header-top {
    background-color: #051c2c;
    color:white;
    padding:8px 0px
  }

    .header__top-infos {
        border-right: 1px solid #e5e5e5;
        padding-top: 0;
        padding-bottom: 0;
    }

    .header__top-infos {
        margin-right: 15px !important;
        padding: 0px 15px 0px 0;
    }

  .header .arm-logo-bermudes {
    margin-top:20px;
    margin-bottom:20px; 
    position: static;
    max-width: 170px;
  }

  /** COMPTOIR MARITIME */
  .logo-comptoirMaritime {
    margin-top:20px;
    margin-bottom:20px; 
    height: 50px;
  }

  #header-comptoirMaritime {
    border-bottom:1px solid #000000;
  }

  #header-top-CM {
    background-color: #aaa676;
    color:white;
    padding:16px 0px
  }

</style>